<template>
  <div>
    <header-component />
    <div class="px-2 py-2 w-full">
      <div class="card">
        <div class="card-header">
          <h3
            class="mb-0"
            style="text-transform: capitalize">Add User</h3>
        </div>
        <div class="card-body">
          <create-user
            :edited-user="editedUser"
            :redirect-to-users="true" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { Select, Option, Radio } from "element-ui";
import headerComponent from "../Components/HeaderComponent";
import createUser from "./CreateUserComponent";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Radio.name]: Radio,
    "header-component": headerComponent,
    "create-user": createUser,
  },
  data: () => {
    return {
      editedUser: {},
    };
  },

  computed: {
    ...mapState("user", ["user"]),
    ...mapGetters({
      roles: "role/getRoles",
    }),
  },
  mounted() {
    this.getRoles();
    if (this.$route.params.userId) {
      this.fetchUser(this.$route.params.userId);
      this.editedUser = this.user;
    }
  },
  methods: {
    ...mapActions({
      saveUser: "user/saveUser",
      updateUser: "user/updateUser",
      getRoles: "role/getRoles",
      fetchUser:"user/fetchUser"
      // getPriceTypes: "product/getProductPriceTypes",
    }),
    ...mapMutations({ resetUser: "user/resetUser" }),

    onSubmit() {
      if (this.user.userId) {
        this.updateUser().then((res) => {
          this.resetUser();
          this.$notify({
            message: "User Updated Succesfully!",
            type: "success",
            title: "Success",
          });
          this.$router.push("/users/list");
        });
      } else {
        this.saveUser().then((res) => {
          this.resetUser();
          this.$notify({
            message: "User Created Succesfully!",
            type: "success",
            title: "Success",
          });
          this.$router.push("/users/list");
        });
      }
    },
  },
};
</script>

